module.exports = __webpack_public_path__ + "static/media/brazil-flag-medium.2aab57b8.png";